<template>
    <div class="container">
      <Header :showBack="false" title="易加网"></Header>
        <div class="container-content" v-if="isLoginSuccess">
            <p class="title">易加网登录失败</p>
            <van-button type="primary" @click="goHome">跳转首页</van-button>
        </div>
        <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
    </div>
</template>

<script>
import { externalLoginApi } from '@/api/bind'
import { userUtils } from '@/utils/auth'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
import Header from '@/components/header'
export default {
  components: {
    Header,
    ReturnToLogin
  },
  data () {
    return {
      appCode: '',
      ts: '',
      sign: '',
      externalUserAccount: '',
      target: '',
      externalClientId: '',
      isLoginSuccess: false
    }
  },
  created () {
    this.init()
  },
  computed: {},

  methods: {
    init () {
      this.appCode = this.$route.query.appCode || ''
      this.ts = this.$route.query.ts || ''
      this.sign = this.$route.query.sign || ''
      this.externalUserAccount = this.$route.query.externalUserAccount || ''
      this.externalClientId = this.$route.query.externalClientId || ''
      this.target = this.$route.query.target || '/v2/home-main'
      this.login()
    },
    login () {
      this.$toast.loading({
        duration: 0,
        message: '登录中...',
        forbidClick: true
      })
      const dataParams = {
        externalUserAccount: this.externalUserAccount,
        externalClientId: this.externalClientId
      }
      const headers = {
        code: this.appCode,
        timestamp: this.ts,
        signature: this.sign
      }
      externalLoginApi.externalLogin(dataParams, headers).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          userUtils.setUserLocal(res.data.resultData)
          if (res.data.resultData.activityCoinDTO) {
            // 回归活动
            this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
          } else {
            this.handleJumpHome()
          }
        } else {
          this.isLoginSuccess = true
        }
      }).catch(() => {
        this.isLoginSuccess = true
        this.$toast.clear()
      })
    },
    handleJumpHome () {
      let target = this.target + '#backHome'
      window.location.replace(target)
    },
    goHome () {
      this.$router.replace({ name: 'home-main' })
    }
  }
}
</script>
<style  scoped lang="less">
.container {
    background-color: #fff;
    height: 100%;
    position: relative;
    line-height: 1.5rem;
    .container-content{
        text-align: center;
        position: absolute;
        transform: translate(-50%,-50%);
        top: 45%;
        left:50%;
        width: 100%;
    }

    .title {
        font-size: 0.75rem;
        color: red;
        font-weight: 700;
    }

}
</style>
